export { default as manuel_cantueso } from './manuel_cantueso.jpg';
export { default as jordi_serra } from './jordi_serra.jpg';
export { default as anna_prieto } from './anna_prieto.jpg';
export { default as pepe_galindo } from './pepe_galindo.jpg';
export { default as quote } from './left-quote-copy-2.svg';
